"use client";

import { useEffect } from "react";
import { BookingErrorFallback } from "@/lib/observability/error-fallback";
import { reportBoundaryError } from "@/lib/observability/report-boundary-error";

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function Error({ error, reset }: ErrorProps) {
  useEffect(() => {
    reportBoundaryError(error, "root");
  }, [error]);

  return (
    <main className="flex min-h-screen items-center justify-center px-4">
      <BookingErrorFallback
        title="Something went wrong"
        body="Try again in a moment. Nothing was booked or changed."
        digest={error.digest}
        actions={[{ label: "Try again", onClick: reset }]}
      />
    </main>
  );
}
